export default "__VITE_ASSET__352dd9a4__"